export default __webpack_public_path__ + "static/media/canvas-background-dark.50876f9f.svg";